import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import i18n from 'i18next';
import PropTypes from 'prop-types';

export class BookingSelectList extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    filterName: PropTypes.string.isRequired,
    headerText: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    search: PropTypes.string,
    style: PropTypes.shape({}),
    label: PropTypes.string,
    name: PropTypes.string,
  }
  static defaultProps = {
    hasSearch: false,
    options: [],
    placeholder: 'Select an Option',
    value: '',
  }
  static getPropsToState = (props) => {
    const value = props.value || '';
    const search = props.search || '';
    return {
      value,
      search,
    };
  }
  constructor(props) {
    super(props);
    const state = BookingSelectList.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = BookingSelectList.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleOnChange = (e, { value }) => {
    this.setState({ value }, () => {
      this.props.onChange(value, this.props.filterName);
    });
  }
  render() {
    const classNames = ['uc-dropdown booking'];
    if (this.state.value.length > 0) {
      classNames.push('selected');
    }
    const options = this.props.options;
    const truncateStyle = {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'inline-block',
      maxWidth: '100%',
    };
    const hasHeader = options && options.some(opt => opt.header);
    if (hasHeader) {
      options.forEach((opt, idx, arr) => {
        if (opt.header) {
          if (idx > 0 && !arr[idx - 1].divider) {
            options.splice(idx, 0, { divider: true });
          }
        }
      });
      return (
        <div className="field">
          <label className="ui" htmlFor={this.props.name} style={{ fontWeight: 'bold', marginBottom: '0.5em', display: 'block' }}>{this.props.label}</label>
          <Dropdown
            fluid
            selection
            scrolling
            floating
            className={classNames.join(' ')}
            disabled={this.props.disabled}
            header={this.props.headerText}
            onChange={this.handleOnChange}
            selectOnBlur={false}
            text={this.state.value && options && options.length > 0 ?
              options.find(o => o.value === this.state.value).text
              : null}
            placeholder={this.props.placeholder}
            value={this.state.value}
            style={this.props.style}
            name={this.props.name}
          >
            <Dropdown.Menu>
              {
                this.props.headerText && <Dropdown.Header content={this.props.headerText} />
              }
              {
                options && options.length > 0 ?
                options.map((opt, idx) => {
                  if (opt.divider) {
                    return (
                      <Dropdown.Divider key={idx} />
                    );
                  }
                  if (opt.header) {
                    return (
                      <Dropdown.Header key={idx} content={opt.text} />
                    );
                  }
                  return (
                    <Dropdown.Item
                      key={idx}
                      value={opt.value}
                      text={opt.text}
                      selected={this.state.value === opt.value}
                      onClick={this.handleOnChange}
                    />
                  );
                })
                : null
              }
            </Dropdown.Menu>
          </Dropdown>
        </div>
      );
    }
    return (
      <div className="field">
        <label className="ui" htmlFor={this.props.name} style={{ fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }}>{this.props.label}</label>
        <Dropdown
          className={classNames.join(' ')}
          disabled={this.props.disabled}
          fluid
          selection
          header={this.props.headerText}
          onChange={this.handleOnChange}
          options={options}
          selectOnBlur={false}
          placeholder={this.props.placeholder}
          value={this.state.value}
          scrolling
          style={this.props.style}
          search
          text={
            this.state.value && options && options.length > 0
              ? <span style={truncateStyle}>{(options.find(o => o.value === this.state.value) || {}).text || this.props.placeholder}</span>
              : this.props.placeholder
          }
          name={this.props.name}
          noResultsMessage={i18n.t('No results found', { ns: 'translation' })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/UCBookingSelectList.jsx